<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import uiStore from '../utils/UIStore';
import Link from './Link.svelte';

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

export let tab = 0;
export let name = 'Home';
export let url = '/';
export let currentTab = 0;
export let callback = (tab) => console.log(uiTexts.navTab.noCallback, tab);
</script>

<div
    class={currentTab === tab ? "tab selected" : "tab"}
    on:click|preventDefault={() => {
        callback(tab);
    }}
>
    <Link
        style="height: 60px;"
        to={url}
    >
        <div>{name}</div>
    </Link>
</div>
